import { render, staticRenderFns } from "./GeocodePrueba.vue?vue&type=template&id=225b37bc&scoped=true&"
import script from "./GeocodePrueba.vue?vue&type=script&lang=js&"
export * from "./GeocodePrueba.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225b37bc",
  null
  
)

export default component.exports